import { lazy, Suspense, useEffect } from "react";
import { useConnection } from "wagmi";
import { TopBar, TabBar } from "./layout/TopBar";
import { SigningSheet, Toaster } from "./layout/Overlays";
import { useRoute } from "./router";
import { follow, refreshAccount } from "./state/account";
import { startAccountToasts } from "./state/actions";
import { useMarkFeed, useTradingState, useWinFee } from "./state/market";
import { useValuationFeed } from "./state/valuation";
import { Trade } from "./views/trade/Trade";

const Portfolio = lazy(() => import("./views/portfolio/Portfolio").then((m) => ({ default: m.Portfolio })));
const Staking = lazy(() => import("./views/staking/Staking").then((m) => ({ default: m.Staking })));
const Stats = lazy(() => import("./views/stats/Stats").then((m) => ({ default: m.Stats })));

/** What runs once for the page: the markets, the marks, the account and its valuations. */
function useVenue() {
  const trading = useTradingState();
  useMarkFeed(trading.data);
  useWinFee();
  useValuationFeed();

  // claimable rewards move with the trading state's accumulator
  useEffect(() => {
    if (trading.data) refreshAccount();
  }, [trading.data]);

  const { address, status } = useConnection();
  useEffect(() => {
    if (status === "connected" && address) follow(address);
    else if (status === "disconnected") follow(null);
  }, [address, status]);

  useEffect(() => startAccountToasts(), []);
}

export function App() {
  const route = useRoute();
  useVenue();
  return (
    <div className="app">
      <TopBar route={route} />
      <Suspense fallback={<div className="page-loading" />}>
        {route.view === "trade" && <Trade coin={route.coin} />}
        {route.view === "portfolio" && <Portfolio />}
        {route.view === "staking" && <Staking />}
        {route.view === "stats" && <Stats />}
      </Suspense>
      <TabBar route={route} />
      <Toaster />
      <SigningSheet />
    </div>
  );
}
